import { render, staticRenderFns } from "./SolidPieChat.vue?vue&type=template&id=9878790e&scoped=true"
import script from "./SolidPieChat.vue?vue&type=script&lang=js"
export * from "./SolidPieChat.vue?vue&type=script&lang=js"
import style0 from "./SolidPieChat.vue?vue&type=style&index=0&id=9878790e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9878790e",
  null
  
)

export default component.exports